import { useState } from 'react';
import { Box, Button, Flex, IconButton } from '@chakra-ui/react';
import { RiAddFill, RiFilter2Line } from 'react-icons/ri';
import { useAuthContext } from '@contexts/auth';
import Loading from '@components/Loading';
import PaginationRouterContainer from '@components/PaginationRouterContainer';

import useGetList from './useGetList';
import AddDialog from './components/AddDialog';
import CampaignCard from './components/CampaignCard';
import Header from './components/Header';
import Filters from './components/Filters';
import SelectedFiltersList from './components/SelectedFiltersList';

const Campaign = () => {
  const { checkIfHasRole } = useAuthContext();

  const [showAddDialog, setShowAddDialog] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const {
    getCampaigns,
    campaigns,
    loading,
    totalPages,
  } = useGetList();

  const getCurrentComponent = () => {
    if (loading && campaigns.length === 0) return <Loading />;

    if (!loading && campaigns.length === 0) {
      return (
        <Box textAlign="center" mt={20} color="gray.500">
          Nenhuma campanha encontrada.
        </Box>
      );
    }

    return (
      <Box opacity={loading ? 0.5 : 1} transition="opacity 0.15s ease">
        <PaginationRouterContainer
          total={totalPages}
        >
          {campaigns.map((campaign) => (
            <CampaignCard
              key={campaign.id}
              campaign={campaign}
              refetch={() => getCampaigns({})}
            />
          ))}
        </PaginationRouterContainer>
      </Box>
    );
  }

  return (
    <Box>
      <Flex justifyContent="space-between" alignItems="flex-end" mb={2}>
        <Flex alignItems="center">
          <Header />
          <IconButton
            variant="ghost"
            color="argos.fg"
            onClick={() => setShowFilters((prev) => !prev)}
          >
            <RiFilter2Line size={24} />
          </IconButton>
        </Flex>
        {checkIfHasRole('CAN_CREATE_CAMPAIGNS') && (
          <Button size="sm" onClick={() => setShowAddDialog(true)}>
            <RiAddFill /> Nova
          </Button>
        )}
      </Flex>

      {showFilters ? (
        <Filters onClose={() => setShowFilters(false)} />
      ) : (
        <SelectedFiltersList />
      )}

      {getCurrentComponent()}

      {showAddDialog && (
        <AddDialog
          handleClose={() => setShowAddDialog(false)}
          afterSubmit={() => getCampaigns({})}
        />
      )}
    </Box>
  );
};

export default Campaign;
